import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["itemIdField", "subtitle"]
  open(event) {
    const button = event.currentTarget
    const itemId = button.dataset.itemId
    const subtitle = button.dataset.subtitle
    this.itemIdFieldTarget.value = itemId
    if (this.hasSubtitleTarget) {
      this.subtitleTarget.textContent = subtitle
    }
  }
}